import control from "./control";
export default {
  mixins: [control],
  inject: {
    $formLayoutBox: {
      default: null
    }
  },
  props: {
    //是否是文字类组件
    isTextContent: {
      type: Boolean,
      default: true
    },
    value: {
      type: [String, Number],
      default: ""
    },
    defaultValue: {
      type: [String, Number],
      default: ""
    },
    // 提示语
    dataCapion: {
      type: String,
      default: ""
    },
    //显示提示文本（移动端）
    showDataCapion: {
      type: Boolean,
      default: true
    },
    // 提示语触发元素
    dataCapionTarget: {
      type: String,
      default: "icon"
    },
    // 提示语展示方式
    dataCapionType: {
      type: String,
      default: "hoverPop"
    },
    padding: {
      type: Array,
      default() {
        return [8, 8, 8, 8];
      }
    },
    //所在栅格布局占比
    colSpan: {
      type: [String, Number],
      default: "24"
    },
    color: {
      type: String,
      default: ""
    }
  },
  design: {
    //设计器是否在组件上产生遮罩
    isMask: false
  },
  data() {
    return {
      $value: "文本"
    };
  },
  computed: {
    getStyle() {
      let style = {};
      if (!this.isDesign) {
        style.padding = _.map(this.padding, (it) => this.unitSize(it)).join(" ");
      }
      return style;
    },
    realColor() {
      return this.$compileColor(this.color);
    }
  },
  watch: {
    value(to) {
      if (!to && this.defaultValue) {
        // todo Express表达式暂未实现
        // let exp = dsf.Express;
        // this.$value = exp.replace(this.defaultValue.text);
        this.$value = this.defaultValue;
      }
    }
  },
  methods: {
    showHelper() {
      this.$openDialog({
        title: "详细描述",
        template: `<div v-html="params.value"></div>`,
        width: "30vw",
        height: "50vh",
        params: {
          value: this.dataCapion
        }
      });
    },
    $getClass() {
      let colSpanClass = [];
      if (!this.isDesign) {
        let colSpan = "";
        if (this.isTextContent && this.$formLayoutBox && this.$parent == this.$formLayoutBox) {
          if (dsf.global.$isMobile) {
            colSpan = 24;
            colSpanClass = ["van-col", "van-col--" + colSpan];
          } else {
            colSpan = this.colSpan ? this.colSpan : this.$formLayoutBox?.colSpan;
            if (parseInt(colSpan || 0)) {
              colSpanClass = ["el-col", "el-col-" + colSpan];
            }
          }
        }
      }
      let res = control.methods.$getClass.call(this);
      res.push.apply(res, colSpanClass);
      return res;
    }
  }
};
